
import React from 'react'
import { useState, useEffect, useCallback } from 'react'
import './index.less'

export default function SlideBar1(props) {
  const [ifon, setIfon] = useState({
    dom: React.createRef(),
    currentX: 0,
    currentY: 0,
    pressX: null,
    pressY: null,
    isPress: false,
    isMove: false,
    lastTimeX: 0,
    value: 0
  })

  const move = useCallback((e) => {
    if (!ifon.isPress) {
      return
    }

    Move(e, ifon, setIfon, props)
  })

  const up = useCallback((e) => {
    if (!ifon.isPress) {
      return
    }
    Up(e, ifon, setIfon)
  })

  useEffect(() => {
    const domIfon = ifon.dom.current.getBoundingClientRect()
    const value = props.value / props.maxNum * domIfon.width
    setIfon({
      ...ifon,
      value: props.value,
      currentX: value,
      lastTimeX: value
    })
  }, [])

  useEffect(() => {
    props.speed && props.speed(ifon.value)
  }, [ifon.value])

  useEffect(() => {
    window.addEventListener('mousemove', move)
    window.addEventListener('mouseup', up)

    return () => {
      window.removeEventListener('mousemove', move)
      window.removeEventListener('mouseup', up)
    }
  })

  return (<div className='SildeBar1' style={{
    ...props.style
  }}>
    <span className='SildeBar1_text'>{props.title}</span>
    <div className='SildeBar1_bar' ref={ifon.dom}>
      <p className='bar_bar' style={{
        width: ifon.currentX + 'px'
      }}><i style={{
          left: ifon.currentX - 6 + 'px'
        }} className='bar_icon' onMouseDown={(e) => {
          setIfon({
            ...ifon,
            isPress: true,
            pressX: e.clientX,
            pressY: e.clientY
          })
        }}></i></p>
    </div>
    <div className='SildeBar1_box'>
      <input className='box_input' value={ifon.value} onChange={(e) => {
        handleValue(e.target.value, ifon, setIfon, props)
      }} />
      <div className='box_box'>
        <i className='box_icon' onClick={() => {
          handleValue(ifon.value + 1, ifon, setIfon, props)
        }}><svg width='12' height='12' viewBox='0 0 18 18' fill='#ccc' data-interactive='true' data-icon='arrow-up'><path d='M14.303 11.3033L13.9495 11.6569C13.7542 11.8521 13.4376 11.8521 13.2424 11.6569L9.00048 7.414L4.75709 11.6569C4.56183 11.8521 4.24525 11.8521 4.04999 11.6569L3.69643 11.3033C3.50117 11.108 3.50117 10.7915 3.69643 10.5962L8.64618 5.64645C8.84144 5.45118 9.15803 5.45118 9.35329 5.64645L14.303 10.5962C14.4983 10.7915 14.4983 11.108 14.303 11.3033Z' fillRule='evenodd'></path><g class='adui-icon-interactive-cover' fill='#000'><path d='M14.303 11.3033L13.9495 11.6569C13.7542 11.8521 13.4376 11.8521 13.2424 11.6569L9.00048 7.414L4.75709 11.6569C4.56183 11.8521 4.24525 11.8521 4.04999 11.6569L3.69643 11.3033C3.50117 11.108 3.50117 10.7915 3.69643 10.5962L8.64618 5.64645C8.84144 5.45118 9.15803 5.45118 9.35329 5.64645L14.303 10.5962C14.4983 10.7915 14.4983 11.108 14.303 11.3033Z' fillRule='evenodd'></path></g></svg></i>
        <i className='box_icon' onClick={() => {
          handleValue(ifon.value - 1, ifon, setIfon, props)
        }}><svg width='12' height='12' viewBox='0 0 18 18' fill='#ccc' data-interactive='true' data-icon='arrow-down'><path d='M14.303 6.7L13.9495 6.34644C13.7542 6.15118 13.4376 6.15118 13.2424 6.34644L9.00048 10.5893L4.75709 6.34644C4.56183 6.15118 4.24525 6.15118 4.04999 6.34644L3.69643 6.7C3.50117 6.89526 3.50117 7.21184 3.69643 7.4071L8.64618 12.3569C8.84144 12.5521 9.15803 12.5521 9.35329 12.3569L14.303 7.4071C14.4983 7.21184 14.4983 6.89526 14.303 6.7Z' fillRule='evenodd'></path><g class='adui-icon-interactive-cover' fill='#000'><path d='M14.303 6.7L13.9495 6.34644C13.7542 6.15118 13.4376 6.15118 13.2424 6.34644L9.00048 10.5893L4.75709 6.34644C4.56183 6.15118 4.24525 6.15118 4.04999 6.34644L3.69643 6.7C3.50117 6.89526 3.50117 7.21184 3.69643 7.4071L8.64618 12.3569C8.84144 12.5521 9.15803 12.5521 9.35329 12.3569L14.303 7.4071C14.4983 7.21184 14.4983 6.89526 14.303 6.7Z' fillRule='evenodd'></path></g></svg></i>
      </div>
    </div>
  </div>)
}

function Move({ clientX, clientY }, ifon, setIfon, props) {
  const domIfon = ifon.dom.current.getBoundingClientRect()
  let x = (clientX - ifon.pressX)
  x = ifon.lastTimeX + x
  if (x < 0) {
    x = 0
  }
  if (x > domIfon.width - 6) {
    x = domIfon.width
  }

  setIfon({
    ...ifon,
    currentX: x,
    isMove: true,
    value: Math.ceil((x / domIfon.width) * props.maxNum)
  })
}

function Up({ clientX, clientY }, ifon, setIfon) {
  setIfon({
    ...ifon,
    isPress: false,
    isMove: false,
    pressX: null,
    pressY: null,
    lastTimeX: ifon.currentX
  })
}

function handleValue(value1, ifon, setIfon, props) {
  let value
  if (value1 === '') {
    value = ''
  } else {
    if (isNaN(parseInt(value1))) {
      value = ifon.value
    } else {
      value = parseInt(value1) > props.maxNum ? props.maxNum : value1
    }
  }
  const domIfon = ifon.dom.current.getBoundingClientRect()

  const z = (value === '' ? 0 : value) / props.maxNum

  setIfon({
    ...ifon,
    currentX: z * domIfon.width,
    lastTimeX: z * domIfon.width,
    value
  })
}

SlideBar1.defaultProps = {
  maxNum: 100,
  value: 50,
  title: 'title'
}

